import { AccountIdentity, RoomId, RoomPid } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const create = createAction(
  "[Telemetry] Create",
  props<{
    roomId: RoomId;
    roomPid: RoomPid;
    accountIdentity: AccountIdentity;
  }>()
);
export const createSuccess = createAction("[Telemetry] Create Success");
export const createFailure = createAction("[Telemetry] Create Failure");
